<export-metadata-summary-detail-modal>

    <dialog class="modal" aria-labelledby="export-metadata-summary-detail-modal-heading">
        <div class="modal-box max-w-lg text-primary">
            <form method="dialog">
                <button class="absolute end-2 top-2 cursor-pointer text-xl"
                        aria-label="{locale?.t('close')}"
                        onclick="{handleCancel}">
                    <i class="icon-clear"></i>
                </button>
            </form>

            <h3 id="export-metadata-summary-detail-modal-heading" class="font-bold text-lg pe-6">{props.entitytitle}</h3>

            <p class="text-sm mt-2 mb-4">{locale?.t('exportdetailmodal_subtitle')}</p>

            <div role="radiogroup" aria-labelledby="export-metadata-summary-detail-modal-heading" class="join flex mt-6 mb-8 mx-4">
                <button type="button"
                        role="radio"
                        aria-checked="{!state.includeResources}"
                        class="btn join-item rounded-s-lg flex-1 {!state.includeResources ? 'btn-primary' : 'bg-white border border-base-300'}"
                        onclick="{() => selectMode(false)}">
                    {locale?.t('exportdetailmodal_summaryview')}
                </button>
                <button type="button"
                        role="radio"
                        aria-checked="{state.includeResources}"
                        class="btn join-item rounded-e-lg flex-1 {state.includeResources ? 'btn-primary' : 'bg-white border border-base-300'}"
                        onclick="{() => selectMode(true)}">
                    {locale?.t('exportdetailmodal_detailview')}
                </button>
            </div>

            <div class="modal-action">
                <form method="dialog" class="flex gap-2">
                    <button class="btn text-primary rounded-lg"
                            aria-label="{locale?.t('cancel')}"
                            onclick="{handleCancel}">{locale?.t('cancel')}</button>
                </form>
                <button class="btn btn-primary rounded-lg flex flex-row items-center gap-2"
                        aria-label="{locale?.t('export_previewcsv')}"
                        onclick="{handleConfirm}">
                    <i class="icon-metalark-eye"></i>
                    {locale?.t('export_previewcsv')}
                </button>
            </div>
        </div>

        <form method="dialog" class="modal-backdrop">
            <button aria-label="{locale?.t('close')}"
                    onclick="{handleCancel}">{locale?.t('close')}</button>
        </form>
    </dialog>

    <script>
        export default {
            includeTools: false,

            state: {
                includeResources: false
            },

            modalEl() {
                return this.$('dialog');
            },

            show() {
                // Always reopen on the default "Summary View".
                this.update({ includeResources: false });
                this.modalEl().showModal();
            },

            close() {
                this.modalEl().close();
            },

            selectMode(includeResources) {
                this.update({ includeResources });
            },

            handleConfirm() {
                if (typeof this.props.onconfirm === 'function') {
                    this.props.onconfirm(this.state.includeResources);
                }
                this.close();
            },

            handleCancel() {
                this.close();
            }
        }
    </script>
</export-metadata-summary-detail-modal>
